import React , { useState } from 'react';
import {Link} from 'react-router-dom'
import './carousel.css';
import ItemsCarousel from 'react-items-carousel';
import bd from '../../images/bd.jpg';
import bd1 from '../../images/bd1.jpg';
import bd2 from '../../images/bd2.jpg';
import bd3 from '../../images/bd3.jpg';
import bd4 from '../../images/bd4.jpg';
import bd5 from '../../images/bd5.jpg';

const Carousel = () => {


    const [activeItemIndex, setActiveItemIndex] = useState(0);
    const chevronWidth = 50;



    return (
        
          <div className='allCarousel' style={{ padding: `0 ${chevronWidth}px` }}>
          <div className = "bonus"> Qui sommes-nous ? </div> 
        <ItemsCarousel
        requestToChangeActive={setActiveItemIndex}
        activeItemIndex={activeItemIndex}
        numberOfCards={1}
        gutter={100}
        infiniteLoop={true}
        leftChevron={<button className='chevronButton'>{'↞'}</button>}
        rightChevron={<button className='chevronButton'>{'↠'}</button>}
        outsideChevron
        chevronWidth={chevronWidth}
        >
       
        
         <img className="brochure" src={bd}  alt='bd'/> 
         <img className="brochure" src={bd1}  alt='bd1'/> 
         <img className="brochure" src={bd2}  alt='bd2'/> 
         <img className="brochure" src={bd3}  alt='bd3'/> 
         <img className="brochure" src={bd4}  alt='bd4'/> 
         <img className="brochure" src={bd5}  alt='bd5'/> 
        
      </ItemsCarousel>

      <div className="wrap">
          <Link className="goLink" to="/mappy"><span>Decouvrir!</span></Link>
      </div>      

    </div>

    );
}


export default Carousel;
